<template>
    <div>
        <section class="info">
            <div class="tw-container">
                <div class="tw-text-center tw-mb-20">
                    <h2 class="tw-pt-12"> 
                        {{$t ('page.home.title') }}
                        <br>
                        <span class="tw-uppercase">
                            {{$t ('page.home.subtitle') }}
                        </span>
                    </h2>
                </div>
                <div class="tw-w-full tw-text-center tw-flex tw-justify-center tw-items-center">
                    <img src="~@/assets/img/calendar.svg" class="calendar">
                </div>
            </div>
        </section>

        <section class="tw-container offer tw-pt-16">
            <div class="icons-grid tw-grid tw-grid-cols-1 lg:tw-grid-cols-3">

                <div class="tw-flex tw-flex-col tw-justify-start tw-items-center">
                    <img src="~@/assets/img/icons/lead-gen.svg">
                    <h2>{{$t ('page.home.grid.lead_gen_title') }}</h2>
                    <p>{{$t ('page.home.grid.lead_gen_text') }}</p>
                </div>

                <div class="tw-flex tw-flex-col tw-justify-start tw-items-center">
                    <img src="~@/assets/img/icons/aff-mrk.svg">
                    <h2>{{$t ('page.home.grid.aff_marketing_title') }}</h2>
                    <p>{{$t ('page.home.grid.aff_marketing_text') }}</p>
                </div>

                <div class="tw-flex tw-flex-col tw-justify-start tw-items-center">
                    <img src="~@/assets/img/icons/emailing.svg">
                    <h2>{{$t ('page.home.grid.emailing_title') }}</h2>
                    <p>{{$t ('page.home.grid.emailing_text') }}</p>
                </div>
            </div>

            <div class="tw-flex tw-w-full tw-justify-center tw-items-center">
                <router-link :to="`/${this.$i18n.locale}/proposition`"><button class="btn-form-page">{{$t ('page.offer.getProposal') }}</button></router-link>
            </div>
        </section>

        <section class="exclusivity">

            <div class="tw-container">
                <h1>{{$t ('page.exclusivity.title') }}</h1>
                <h3>{{$t ('page.exclusivity.subtitle') }}</h3>

                <div class="exclusivity-grid tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-w-full">
                    <div class="tw-flex tw-flex-col tw-justify-start tw-items-center" :data-content="$t('page.exclusivity.free')">
                        <img src="~@/assets/img/icons/newsletter.svg">
                        <h2>{{$t ('page.exclusivity.newsletter') }}</h2>
                    </div>

                    <div class="tw-flex tw-flex-col tw-justify-start tw-items-center" :data-content="$t('page.exclusivity.free')">
                        <img src="~@/assets/img/icons/banners.svg">
                        <h2>{{$t ('page.exclusivity.banners') }}</h2>
                    </div>
                </div>

                <div class="tw-flex tw-w-full tw-justify-center tw-items-center">
                    <router-link :to="`/${this.$i18n.locale}/proposition`"><button class="btn-form-page">{{$t ('page.offer.getProposal') }}</button></router-link>
                </div>
            </div>
        </section>

        <section class="about">
            <div class="tw-container">
                <h3>{{$t ('page.about.title')}}</h3>

                <div class="tw-flex tw-flex-col lg:tw-flex-row">
                    <div class="tw-flex-1 img-container">
                        <img src="~@/assets/img/about-kwanko.jpg">
                    </div>
                    <div class="tw-flex-1 tw-pt-4 lg:tw-pt-0 lg:tw-pl-12">
                        <p class="tw-mb-4" v-for="line in $t('page.about.description')" :key="line" v-html="line"></p>
                    </div>
                </div>
            </div>

            <div class="tw-flex tw-w-full tw-justify-center tw-items-center">
                <router-link :to="`/${this.$i18n.locale}/proposition`"><button class="btn-form-page">{{$t ('page.offer.getProposal') }}</button></router-link>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: 'Home',
    mounted() {
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
    },

};
</script>
